import { render } from "./ApprovalsView.vue?vue&type=template&id=5010e4cd"
import script from "./ApprovalsView.vue?vue&type=script&lang=js"
export * from "./ApprovalsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__